import React from "react"
import { useParams } from "react-router-dom"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DbTaskComponent } from "../../components/dbTask"
import { DefaultPageComp } from "../../components/defaultPage"

export const DbTaskPage = () => {
  const { id } = useParams()
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <DbTaskComponent id={id ? Number(id) : undefined} />
    </DefaultPageComp>
  </>
}